import React from 'react';

const ShippingPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Shipping Policy</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">Domestic Logistics & Delivery Agreements</p>
      
      <div className="space-y-6 text-xs leading-relaxed font-serif text-zinc-700">
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">1. Logistics Processing Windows</h4>
          <p>All finalized premium orders are organized and prepared inside our fulfillment hubs within **1 to 2 business working days**. Standard manufacturing lines running custom collections may add 24 hours of optimization time before transit assignment.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">2. Estimated Delivery Timelines</h4>
          <p>Modische Kledings partners with automated third-party networks (including Shiprocket, Delhivery, and Blue Dart Air Link services). Consignments reach destinations securely within **3 to 7 calendar business days** post-dispatch, depending on geographical state zones across India.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">3. Transit Trace Visibility</h4>
          <p>The second you dispatch an asset transaction, an official Waybill Airway Code tracking string (AWB) attaches securely to your account profile order logs window, providing clickable, real-time live routing visibility inside our web app portal layout.</p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyPage;